import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { rgba } from 'polished'
import { getTheme, getVars } from '../../global/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import Tip from './Tip'

const CheckboxWrapper = styled.div`
  margin-bottom: ${getTheme('spacer', 'l')};

  input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  label {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-size: ${(props) =>
      (props.size === 'xsmall' && getTheme('fontSize', 'caption')) ||
      (props.size === 'small' && getTheme('fontSize', 'note')) ||
      (props.size === 'medium' && getTheme('fontSize', 'body')) ||
      (props.size === 'large' && getTheme('fontSize', 'title')) ||
      getTheme('fontSize', 'body')};
  }

  .label {
    line-height: 1;
    color: ${getTheme('textColor', 'alt')};
  }

  .check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-right: ${getTheme('spacer', 's')};
    border-radius: ${getTheme('radius', 'xxs')};
    border: 2px solid ${getTheme('black', '_800')};
    width: ${(props) =>
      (props.size === 'xsmall' && getTheme('inputHeight', 'xs')) ||
      (props.size === 'small' && getTheme('inputHeight', 's')) ||
      (props.size === 'medium' && getTheme('inputHeight', 'm')) ||
      (props.size === 'large' && getTheme('inputHeight', 'l')) ||
      getTheme('inputHeight', 'm')};
    height: ${(props) =>
      (props.size === 'xsmall' && getTheme('inputHeight', 'xs')) ||
      (props.size === 'small' && getTheme('inputHeight', 's')) ||
      (props.size === 'medium' && getTheme('inputHeight', 'm')) ||
      (props.size === 'large' && getTheme('inputHeight', 'l')) ||
      getTheme('inputHeight', 'm')};

    svg {
      display: none;
      position: absolute;
      color: ${getTheme('active', '_400')};
    }
  }

  input:checked ~ .check svg {
    display: block;
  }

  label:hover input:not([disabled]) ~ .check {
    border-color: ${getTheme('black', '_600')};
  }

  label:hover input:checked ~ .check svg {
    color: ${getTheme('active', '_300')};
  }

  input:active ~ .check {
    border-color: ${getTheme('black', '_400')};
  }

  input:active ~ .check svg {
    border-color: ${getTheme('active', '_200')};
  }

  input:focus ~ .check {
    box-shadow: 0 0 0 4px ${rgba(getVars('bg', 'active'), 0.25)};
    border-color: ${getTheme('black', '_600')};
  }

  ${(props) =>
    props.error &&
    css`
      input {
        border-color: ${getTheme('textColor', 'errorLight')};
      }
      input:hover {
        border-color: ${getTheme('textColor', 'error')};
      }
    `};

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.25;
      label:hover {
        cursor: not-allowed;
      }
    `};
`

class Checkbox extends Component {
  render() {
    const hasTip = this.props.tip
    const success = this.props.success
    const error = this.props.error
    let tipWrapper = ''
    if (hasTip) {
      tipWrapper = <Tip>{this.props.tip}</Tip>
    }
    if (success) {
      tipWrapper = <Tip success>{this.props.success}</Tip>
    }
    if (error) {
      tipWrapper = <Tip error>{this.props.error}</Tip>
    }
    return (
      <CheckboxWrapper
        error={this.props.error}
        success={this.props.success}
        disabled={this.props.disabled}
        size={this.props.size}
      >
        <label>
          <input type="checkbox" disabled={this.props.disabled} />
          <span className="check">
            <FontAwesomeIcon icon={faCheck} />
          </span>
          <span className="label">{this.props.label}</span>
        </label>
        {tipWrapper}
      </CheckboxWrapper>
    )
  }
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/forms/Checkbox.js